module.exports = __webpack_public_path__ + "media/images/es/logo-conecta-d87fb0128ed0f0575d04cefdcdb2b48f.png";